module.exports = __webpack_public_path__ + "static/img/logo.a2dfb447.png";